import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { ProFunnelService } from "../../../../service/api/builk/profunnel.service";
import { ISubscription } from "rxjs/Subscription";
import { AddressService } from "../../../../service/api/builk/address.service";

@Component({
  selector: "bo-builk-profunnel-project",
  templateUrl: "./profunnel-project.component.html",
  styleUrls: ["./profunnel-project.component.scss"]
})
export class ProFunnelProjectComponent implements OnInit, OnDestroy {
  @ViewChild("template") template: TemplateRef<any>;

  constructor(
    private modalService: BsModalService,
    public router: Router,
    private proFunnelService: ProFunnelService,
    private addressService: AddressService
  ) { }

  modalRef: BsModalRef;
  subscription: ISubscription;

  // number
  companySurrKey: number;
  activeProject: number;

  // string;
  companyName: string;

  // boolean
  isLoading: boolean = false;

  companyProject: Array<any> = [];

  provinceOption: Array<{id: string, text: string}> = [];

  ngOnInit(): void {
  }

  openModal(id: number, companyName: string): void {
    this.modalRef = this.modalService.show(this.template, {
      class: "modal-lg"
    });
    this.companyProject = [];
    this.companySurrKey = id;
    this.companyName = companyName;
    this.getCompanyProject(id);
    if (this.provinceOption.length == 0) {
      this.getProvince('TH', 'th');
    }
  }

  getCompanyProject(companySurrKey: number): void {
    this.isLoading = true;
    this.subscription = this.proFunnelService.getCompanyProject(companySurrKey)
      .subscribe(
        response => {
          this.companyProject = response;
          this.activeProject = response.length;
          this.isLoading = false;
        }
      );
  }

  close() {
    this.modalRef.hide();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getProvince(countryCode: string, language: string): any {
    this.addressService.getProvince(countryCode, language).subscribe(res => {
      this.provinceOption = res.map(x => {
        return {
          id: x.id,
          text: x.text
        };
      })
    });
  }

  getProvinceName(id: string) {
    let province = this.provinceOption.filter(x => x.id == id);
    if (province.length > 0) {
      return province[0].text;
    }
    return id;
  }
}
